import lessRequire from '../../config/less-require-resolver';
import React from  'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import { getCurrencyIcon } from '../../../shared/js/get-currency-icon';

lessRequire('modules/shared/currency-switch.less');

const propTypes = {
	listOfCurrencies: PropTypes.array,
	activeCurrency: PropTypes.string,
	onSwitch: PropTypes.func
};

const CurrencySwitch = ({
	listOfCurrencies,
	activeCurrency,
	onSwitch,
	buttonsType = ''
}) => (
	<div className="currency-switch">
		{ listOfCurrencies.map(entity => (
			<button
				key={entity.id}
				onClick={() => entity.id !== activeCurrency && onSwitch(entity.id)}
				className={cn({
					'currency-switch__btn': true,
					'currency-switch__btn--active': entity.id === activeCurrency
				})}
				type={buttonsType}
			>
				{getCurrencyIcon(entity.id)}
			</button>
		)) }
	</div>
);

CurrencySwitch.propTypes = propTypes;
export default CurrencySwitch;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/currency-switch.js